import { assets } from './campaign';

const serviceItems = [
  'Current Galveston City Council Member for District 5.',
  'Elected in 2024 and running for re-election in the 2026 runoff.',
  'Galveston builder and restoration professional with hands-on experience in local projects.',
  'Focused on public safety, lower taxes, better roads and drainage, and responsive constituent service.',
];

const background = [
  'Beau Rawlins is a Galveston builder, restoration professional, and District 5 City Council Member who brings a hands-on approach to local government.',
  'His work in building, renovation, restoration, and project management gives him a practical view of the issues residents deal with every day: streets, drainage, permits, code enforcement, public safety, historic neighborhoods, and responsible growth.',
  'Beau is running to keep District 5 represented by someone accessible, practical, and focused on following through for Galveston neighborhoods.',
];

function AboutPage() {
  return (
    <main className="bg-white">
      <section className="bg-[#f8f1fb] px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[0.92fr_1.08fr] lg:items-center">
          <div className="relative">
            <div className="absolute -left-5 -top-5 size-full rounded-[2rem] bg-[#f2b800]" />
            <img
              src={assets.headshot}
              alt="Beau Rawlins"
              className="relative z-10 w-full rounded-[2rem] border-8 border-white object-cover shadow-2xl"
            />
          </div>
          <div>
            <p className="font-black uppercase tracking-[0.2em] text-[#8f6400]">Meet Beau</p>
            <h1
              className="mt-3 text-5xl font-black leading-tight text-[#6f2182]"
              style={{ fontFamily: 'Source Serif 4, serif' }}
            >
              A practical voice for District 5.
            </h1>
            <div className="mt-7 space-y-5 text-lg leading-8 text-[#66546f]">
              {background.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <p className="font-black uppercase tracking-[0.2em] text-[#8f6400]">Experience</p>
            <h2
              className="mt-3 text-4xl font-black text-[#6f2182]"
              style={{ fontFamily: 'Source Serif 4, serif' }}
            >
              Hands-on experience. Real follow-through.
            </h2>
            <p className="mt-5 text-lg leading-8 text-[#66546f]">
              Beau understands what it takes to maintain a coastal city because he has spent years
              working on the kinds of projects that shape daily life in Galveston. That experience
              informs how he approaches city service: practical decisions, clear communication, and
              steady attention to the basics residents count on.
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              {serviceItems.map((item) => (
                <div key={item} className="rounded-2xl bg-[#f8f1fb] p-5 shadow-lg">
                  <p className="font-bold leading-7 text-[#6f2182]">{item}</p>
                </div>
              ))}
            </div>
          </div>
          <aside className="rounded-[2rem] bg-[#6f2182] p-8 text-white shadow-xl">
            <img
              src={assets.adPrimary}
              alt="Beau Rawlins campaign ad"
              className="rounded-2xl bg-white object-cover shadow-lg"
            />
            <h3 className="mt-7 text-2xl font-black">Campaign focus</h3>
            <p className="mt-4 leading-7 text-white/80">
              Keep District 5 safe, responsive, resilient, and true to Galveston&apos;s character.
            </p>
          </aside>
        </div>
      </section>
    </main>
  );
}

export default AboutPage;
